import React from 'react';

import { ViewHead } from 'components/shared/Assets/ViewModal/ViewHead';
import View from 'components/shared/FileDropZone/View';
import FormGroup from 'components/shared/FormAdapters/FormDefault/FormGroup/Base';
import Tag from 'components/shared/FormAdapters/FormDefault/TagsInput/Tag';
import FormTitle from 'components/shared/Typography/FormTitle';
import i18n from 'i18n';

import s from './index.module.css';
import { IPreviewProps } from './types';

export function Preview(props: IPreviewProps) {
  const { currentFile } = props;

  if (currentFile.id) {
    return (
      <div className={s.wrapper}>
        <ViewHead isDocument asset={currentFile} isCenter />
        <FormGroup>
          <View
            url={currentFile.url}
            type={currentFile.mimeType}
            filename={currentFile.filename}
            dynamic
            fileAccId={currentFile?.accountId}
            assetStorageType={currentFile.storageType}
          />
        </FormGroup>

        <FormTitle>{i18n.t('proposal_content.tags')}</FormTitle>
        <div style={{ marginTop: '-1.8rem' }}>{currentFile?.tags.map((t: string) => <Tag key={t} title={t} />)}</div>
      </div>
    );
  }

  return null;
}
